import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// get recent credit transactions
async function attemptCreditTransactionHistory(page,page_size,token,searchTerm) {
    const params = new URLSearchParams({
        page,
        page_size
    })

    if (searchTerm) params.append('search',searchTerm)

    const response = await fetch(`${API_URL}/payments/credit_transaction/?${params.toString()}`,{
        method:'GET',
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json()

    if(!response.ok){
        const err = new Error("Failed to fetch the credit transaction history");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get the credit transaction history
export async function listCreditTransactionHistory(page,page_size,searchTerm) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptCreditTransactionHistory(page,page_size,accessToken,searchTerm)
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptCreditTransactionHistory(page, page_size, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting Credit transaction history", error?.data || error.message);
        throw error;
    }
}

// helper to get the credit transaction per product
async function attemptGetCreditTransactionsPerProduct(token) {
    const response = await fetch(`${API_URL}/payments/credit_transaction_per_product/`,{
        method:'GET',
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the pay transaction history per product");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get py transaction history per product
export async function listCreditTransactionHistoryPerProduct() {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try{
        return await attemptGetCreditTransactionsPerProduct(accessToken)
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptGetCreditTransactionsPerProduct(newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting pay transaction history per prouduct", error?.data || error.message);
        throw error;
    }
}